module.exports = __webpack_public_path__ + "static/media/civic-logo-invert.a4b7b7b1.svg";